import { FullScreenLoaderProvider } from "app/context/FullScreenLoaderContext";
import { DocumentViewerProvider } from "app/providers/DocumentViewerProvider";
import { CameraCaptureProvider } from "app/providers/CameraCaptureProvider";
import { GuestTokenProvider } from "app/providers/GuestTokenProvider";
import { AccountDetailsProvider } from "app/providers/AccountDetailsProvider";
import { PermissionProvider } from "providers/PermissionProvider";
import { RouterProvider } from "react-router-dom";
import router from "./routes/routes";
import "./styles/index.css";

function App() {
  return (
    <FullScreenLoaderProvider>
      <GuestTokenProvider>
        <AccountDetailsProvider>
          {/* <PermissionProvider> */}
          <DocumentViewerProvider>
            <CameraCaptureProvider>
              <RouterProvider router={router} />
            </CameraCaptureProvider>
          </DocumentViewerProvider>
          {/* </PermissionProvider> */}
        </AccountDetailsProvider>
      </GuestTokenProvider>
    </FullScreenLoaderProvider>
  );
}

export default App;
